import { Container, LinearProgress } from "@mui/material";
import React from "react";
import TerminalContext from "./context";
import TabsView from "./tabsView";
import { useCustomerManager } from "./useCustomer";

const Main = () => (
  <TerminalContext.Provider value={useCustomerManager()}>
    <TabsView />
  </TerminalContext.Provider>
);

export default React.memo(Main);
